import { render, staticRenderFns } from "./WorkFrontDialogComponent.vue?vue&type=template&id=6ddd80cc&scoped=true"
import script from "./WorkFrontDialogComponent.js?vue&type=script&lang=js&external"
export * from "./WorkFrontDialogComponent.js?vue&type=script&lang=js&external"
import style0 from "./WorkFrontDialogComponent.vue?vue&type=style&index=0&id=6ddd80cc&prod&scoped=true&lang=scss"
import style1 from "./WorkFrontDialogComponent.vue?vue&type=style&index=1&id=6ddd80cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ddd80cc",
  null
  
)

export default component.exports